"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrganizationIdentifier = void 0;
function isOrganizationIdentifier(value) {
    var isValid = true;
    var errors;
    var organizationIdentifierRegex = /^\d{3,20}$/;
    return !value || !value.match(organizationIdentifierRegex)
        ? {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    isValidOrganizationIdentifier: "false",
                },
            },
        }
        : {
            isValid: isValid,
            errors: errors,
        };
}
exports.isOrganizationIdentifier = isOrganizationIdentifier;
